import { DutyCode, DutyHourType } from 'generated';

import {
  Holidays,
  OrganisationPreferences,
  TenantDetails,
  UserDetails,
  UserPreferences
} from './types';
import { PlanGroup, PlanUnit, WorkAgreement } from 'components/types';

import { UserGrants } from 'utils/grants';

import {
  DhtsAction,
  DutyCodesAction,
  EmployeePlanUnitsAction,
  HolidaysAction,
  OrganisationPreferencesAction,
  PlanGroupsAction,
  PlanUnitsAction,
  PrefAction,
  PublicPlanUnitsAction,
  TenantDetailsAction,
  UserDetailsAction,
  UserGrantsAction,
  WorkAgreementsAction
} from './actionCreators';

export function userDetails(
  state = {} as UserDetails,
  { type, payload }: UserDetailsAction
) {
  switch (type) {
    case 'SET_USER_DETAILS':
      return payload;
    default:
      return state;
  }
}

export function tenantDetails(
  state = {} as TenantDetails,
  { type, payload }: TenantDetailsAction
) {
  switch (type) {
    case 'SET_TENANT_DETAILS':
      return payload;
    default:
      return state;
  }
}

export function preferences(
  state: UserPreferences = {} as UserPreferences,
  action: PrefAction
): UserPreferences {
  switch (action.type) {
    case 'SET_PREFERENCES': {
      const userPreferences = action.payload;
      return {
        ...userPreferences,
        showSourcePlanUnitEmployeeRoster:
          userPreferences.rosterEmployeeGridSourceCostCenter === 'show'
      };
    }
    case 'SET_PREFERENCE': {
      const { key, value } = action.payload;
      return {
        ...state,
        [key]: value
      };
    }

    default:
      return state;
  }
}

export function grants(
  state = {} as UserGrants,
  { type, payload }: UserGrantsAction
) {
  switch (type) {
    case 'SET_GRANTS':
      return payload;
    default:
      return state;
  }
}

export function organisationPreferences(
  state = {} as OrganisationPreferences,
  action: OrganisationPreferencesAction
) {
  switch (action.type) {
    case 'SET_ORG_PREF':
      return action.payload;
    default:
      return state;
  }
}

export function planGroups(
  state: PlanGroup[] = [],
  { type, payload }: PlanGroupsAction
) {
  switch (type) {
    case 'SET_PLANGROUPS':
      return payload;
    default:
      return state;
  }
}

export function planUnits(
  state: PlanUnit[] = [],
  { type, payload }: PlanUnitsAction
) {
  switch (type) {
    case 'SET_PLANUNITS':
      return payload;
    default:
      return state;
  }
}

export function employeePlanUnits(
  state: PlanUnit[] = [],
  { type, payload }: EmployeePlanUnitsAction
) {
  switch (type) {
    case 'SET_EMPLOYEE_PLANUNITS':
      return payload;
    default:
      return state;
  }
}

export function publicPlanUnits(
  state: PlanUnit[] = [],
  { type, payload }: PublicPlanUnitsAction
) {
  switch (type) {
    case 'SET_PUBLIC_PLANUNITS':
      return payload;
    default:
      return state;
  }
}

export function dutyCodes(
  state: DutyCode[] = [],
  { type, payload }: DutyCodesAction
) {
  switch (type) {
    case 'SET_DUTYCODES':
      return payload;
    default:
      return state;
  }
}

export function dhts(
  state: DutyHourType[] = [],
  { type, payload }: DhtsAction
) {
  switch (type) {
    case 'SET_DHTS':
      return payload;
    default:
      return state;
  }
}

export function holidays(state = {} as Holidays, action: HolidaysAction) {
  const { type } = action;

  switch (type) {
    case 'SET_HOLIDAYS':
      if ('payload' in action) {
        return action.payload;
      }
      return state;
    default:
      return state;
  }
}

export function workAgreements(
  state: WorkAgreement[] = [],
  { type, payload }: WorkAgreementsAction
) {
  switch (type) {
    case 'SET_WORK_AGREEMENTS':
      return payload;
    default:
      return state;
  }
}
